export { FranchiseView } from './FranchiseView'
